<template lang="pug">
.theme.skin(:class='themeNamespace')
  accounts(ref='accounts' @dismiss='switchAccountAfterLogin = false')
  keep-alive
    component.layout(v-if='!switchAccountAfterLogin' :is='layout', :reference='refName' :class='{ embedded: featureFlags.legacyViewDisabled }')
      component.module(:is='module()', :class='className' ref='currentModule')
</template>

<script>
/* eslint no-multi-spaces: 0 */
import featureFlags      from '@/core/feature-flags/feature-flags'
import User              from '@/core/user'
import Accounts          from '@/components/Login/accounts'
import themes            from '@/assets/sass/themes/index.scss'
import Layouts           from '@/components/Layouts'
import _Components       from '@/components/_modules'

import router            from '@/router'

import notImplemented    from '@/components/GeneralViews/NotFound.vue'
import legacyModule      from '@/components/LegacyContainer'
import loadingIndicators from '@/core/loading-indicators'

import LegacyAuth        from '@/core/legacy-auth'
import tabs              from '@/core/site-map/map.json'
import legacyRouter      from '@/components/LegacyContainer/legacyRouter'
import { routeOldLinks } from '@/components/LegacyContainer/routeOldLinks'

// import tour              from '@/components/tour'

const { allowedModules } = LegacyAuth

let Components = null

export default {
  components: {
    Accounts
  },

  beforeCreate() {
    Components = _Components.__get()
    // tour.init()

    legacyRouter.methods.polyfillParent.call(this)
  },

  beforeRouteUpdate(to, from, next) {
    let fromModule = getModule(from)
    let moduleContext = this.$refs.currentModule

    this.$loading = false

    //
    this.$store.state.gridExpandOffset = {}

    if (fromModule && typeof fromModule.beforeLeave === 'function' && to.path !== from.path) {
      !fromModule.beforeLeave.apply(moduleContext)
        ? this.$notifications.notify(
          {
            type: 'plain',
            icon: 'exclamation-circle',
            placement: { from: 'top', align: 'center' },
            timeout: 0,
            message: `Are you sure you want to navigate away ?`,
            dismiss: 'Yes',
            discard: 'No',
            goto: null,
            onClose: function (dismiss) {
              if (dismiss) {
                //
                next()
              } else if (dismiss === null) {
                //
              }
            }
          })
        : next()
    } else {
      next()
    }
  },

  created() {
    if (
      featureFlags.legacyViewDisabled &&
      document.referrer.indexOf('noSwitchAccount') === -1
    ) routeOldLinks.call(this, this.$route)
  },

  mounted() {
    if (global.config.enableThemes) this.applyTheme()

    this.switchAccountAfterLogin = this.$refs.accounts.switchAccountAfterLogin
  },

  computed: {
    themeNamespace: () => {
      if (global.config.enableThemes && global.config.namespace) {
        return global.config.namespace + ' default'
      }
      if (User.get() && User.get().theme && themes[User.get().theme]) {
        return themes[User.get().theme]
      }
      return 'default'
    },

    layout() {
      const app    = this._self
      const route  = app.$route
      let module   = Components[route.params.page || route.name]

      // always use `navless` layout on `create` action
      if (route.params.action === 'create') return Layouts.navless

      if (route.params.section &&
        Components[route.params.page + '/' + route.params.section]
      ) {
        module = Components[route.params.page + '/' + route.params.section]
      }

      if (module && module.layout) {
        return Layouts[module.layout].default
      } else {
        // return Layouts.default
        if (global.config.layout) return Layouts[global.config.layout].default || Layouts.default.default
        return Layouts.other.default
      }
    }
  },

  data() {
    return {
      featureFlags,
      hasAccounts: true,
      switchAccountAfterLogin: false,
      showLeaveConfirmation: false,
      className: '',
      refName: '',

      module(fromRoute) {
        const app     = this._self
        const route   = fromRoute || app.$route

        skipToSubmodule.call(this)
        const module = getModule(route)
        // check allowed
        if (module && module.notAllowed) return notImplemented

        // if (module.notImplemented) return notImplemented

        // legacy modules
        global.app.currentModule = app.$root.currentModule = (route.params.section || route.params.page || route.name).split('-')[0]
        if (route.params.namespace === 'i' || (module && module.notImplemented && module.notImplemented !== 'yet')) {
          return legacyModule
        }
        this.className = module && module.legacy ? 'legacy' : ''

        if (module) {
          module
            .on('afterLoad', () => { loadingIndicators.hook.stop.call(app)/* ; tour.show(route) */ })
            .on('beforeLoad', () => loadingIndicators.hook.start.call(app))

          global.app.backReference = this.refName = module.reference || ''

          global.Intercom && global.Intercom('update', {
            ...global.intercomSettings,
            last_request_at: parseInt((new Date()).getTime() / 1000)
          })

          //
          let beforeLeaveHook = (module.module || module).beforeLeave
          if (typeof beforeLeaveHook === 'function') {
            // app.$store.state.pendingData = !beforeLeaveHook()
            window.addEventListener('beforeunload', beforeLeave)
            // console.log('attached hook')
          } else {
            // console.log('detached hook')
            window.removeEventListener('beforeunload', beforeLeave)
          }
          return module.module || module
        } else {
          return route.params.section ? legacyModule : notImplemented
        }
      }
    }
  },

  methods: {
    applyTheme() {
      //
      var theme = document.querySelector('.' + this.themeNamespace)
      var themeId = null

      if (theme) {
        /* if (theme.currentStyle) {
          themeId = theme.currentStyle['-content']
        } else {
          themeId = getComputedStyle(theme).content
        } */
        themeId = getComputedStyle(theme, ':before').content

        themeId = themeId && themeId.replace(/"/g, '')
        theme.className += ' ' + themeId
      }
    },
    doNext() {}
  }
}

function beforeLeave(e) {
  let moduleContext = document.querySelector('.theme.skin').__vue__.$refs.currentModule
  let moduleHook = !document.querySelector('.theme.skin').__vue__.module(router.currentRoute).beforeLeave.apply(moduleContext)
  // e.preventDefault()
  if (moduleHook) {
    e.returnValue = ''
  }
}

/**
 * Returns the module based on route
 *
 * @param {object} route - current route
 * @returns {object} module
 */
function getModule(route) {
  var module = Components[route.params.page || route.name]
  const allowed = allowedModules.get[route.params.page]

  // docs
  if (route.params.namespace === 'docs' && !module) {
    // return notImplemented
  }

  // pack submodule action
  if (module && module.pack && route.params.action) {
    module =
      Components[route.params.section + '-' + route.params.action] ||
      Components[route.params.section + (route.params.action ? '/' + route.params.action : '')] ||
      Components[route.params.page + '/' + route.params.section.replace('>', '') + (route.params.action ? '/' + route.params.action : '')]
  }
  // pack submodule
  if (module && module.pack && route.params.section) {
    module = Components[route.params.section]
  }

  // submodule
  if (route.params.section &&
    Components[route.params.page + '/' + route.params.section]
  ) {
    module = Components[route.params.page + '/' + route.params.section]
  }

  // config sitemap
  if (route.params.section &&
    global.config.namespace &&
    global.config.sitemap &&
    global.config.sitemap[global.config.namespace] &&
    global.config.sitemap[global.config.namespace][route.params.page] &&
    global.config.sitemap[global.config.namespace][route.params.page].subtabs &&
    global.config.sitemap[global.config.namespace][route.params.page].subtabs[route.params.section]
  ) {
    module = Components[route.params.page + '/' + route.params.section]
  }

  if (!(allowed && allowed.entry)) {
    if (module) module.notImplemented = Components[route.params.page] ? Components[route.params.page].notImplemented : false
  }

  return module
}

/**
 * Navigates to first module in pack or to configured entry point
 */
function skipToSubmodule() {
  if (this.$router.currentRoute.params.namespace === 'docs') return

  const route       = this.$router.currentRoute
  const module      = Components[route.params.page || route.name]

  const allowed     = allowedModules.get[route.params.page]

  const submodules  = tabs[route.params.page] && tabs[route.params.page].pack || null
  const subtabs     = Components[route.params.page] && Components[route.params.page].notImplemented ||
                      Components[route.params.page] && Components[route.params.page].pack

  if (allowed && allowed.entry && !route.params.section) {
    this.$router.push(allowed.entry)
    return
  }

  if (!module || !allowed) return notImplemented
  if (!allowed.subtabs) return

  const first = allowed.subtabs[Object.keys(allowed.subtabs)[0]]
  const firstModule = submodules /* && !module.notImplemented */
                      ? submodules[first] && submodules[first].name ||
                        submodules[first]
                      : first && first.name ||
                        first

  //
  const defaultModule = submodules && Object.keys(submodules).filter(k => ~k.indexOf('#'))[0].replace('#', '')
  const namespace = Components[firstModule] && !module.notImplemented ? 'd' : 'i'

  if (defaultModule && !route.params.section) {
    this.$router.push('/' + namespace + '/' + route.params.page + `/?goto=${defaultModule}`)
  }

  if (firstModule && allowed && !route.params.section && subtabs) {
    let gotopage = route.query.goto ? `?goto=${route.query.goto}` : ''
    const url = '/' + namespace + '/' + route.params.page + '/' + firstModule + '/' + gotopage

    this.$router.push(url)
  }

  if (module && module.entry && !route.params.section) {
    this.$router.push(module.entry)
  }
}

</script>



// WEBPACK FOOTER //
// src/components/Layouts/shell/index.vue